'use strict';

var FlightAnalysisModePanelController = function FlightAnalysisModePanelController($scope) {
  $scope.$on('flight-analysis:kpi-ribbon-collapsed', function (event, kpiRibbonCollapsed) {
    $scope.kpiRibbonCollapsed = kpiRibbonCollapsed;
  });
};
FlightAnalysisModePanelController.$inject = ['$scope'];
module.exports = FlightAnalysisModePanelController;